import ChecklistCompleteLogo from "~/images/checklistComplete.svg"

export interface SignUpSuccessProps {
  landingBackButtonUrl: string
  signUpText: Record<string, string>
}
export default function SignUpSuccess({ signUpText }: SignUpSuccessProps) {
  return (
    <div className="flex flex-col items-center lg:items-start">
      <img src={ChecklistCompleteLogo} alt="Book Logo" className="w-80 my-4" />
      <p>{signUpText.done}</p>
    </div>
  )
}
